<template>
  <div :class="'routeMap route-' + route.id">
    <div class="routeMapInner">
      <div class="map-wrapper">
        <div ref="map" class="map" v-bind:id="'map' + route.id"></div>
        <!--<figure class="urs-favourite urs">
          <img src="../assets/urs_bubble.svg" />
          <figcaption>
            <p>Gute Wahl!</p>
          </figcaption>
        </figure>-->
      </div>
      <section class="routeDetails">
        <div class="title-mode-header">
          <h2>{{ from }} <img src="../assets/icons/arrow-right.svg"> {{  to  }}</h2>
        </div>
        <article class="routeDetail"><strong>Reisezeit</strong><span>{{ route.duration }}</span></article>
        <router-link to="/route" class="backToOverview"><img src="../assets/icons/arrow-right.svg"> Routenauswahl</router-link>
      </section>
    </div>
  </div>
</template>

<script>
import { generateRouteOnMap, mapStyle } from '../js/maps';

export default {
  name: 'RouteMap',
  props: {
    route: {
      type: Object,
      required: true,
    },
    useContentful: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  async mounted() {
    /**
     * Maps
     * Erst ausführen, wenn Vue content ersetzt hat --> wrap in this.$nextTick(function() {}
     */
    this.$nextTick(() => {
      // console.log(this.$refs); // refs statt id -> funktioniert als component
      const mapContainer = this.$refs.map; // instead of document.getElementById('map1')

      const options = {
        zoom: 9,
        center: new google.maps.LatLng(47.0324233, 7.888315),
        disableDefaultUI: true,
        styles: mapStyle,
      };
      this.map = new google.maps.Map(mapContainer, options);

      const partRouteArray = this.route.partRoutes;
      if (partRouteArray) {
        generateRouteOnMap(partRouteArray, this.map, this.route);
      }
    });
  },
  computed: {
    from() {
      if (this.route.locations) {
        return this.route.locations[0].fields.title;
      }
      return '';
    },
    to() {
      if (this.route.locations) {
        return this.route.locations[1].fields.title;
      }
      return '';
    },
  },
  watch: { // props oder data überwachen
    route() {
      if (this.useContentful) {
        const partRouteArray = this.route.partRoutes;

        if (partRouteArray) {
          generateRouteOnMap(partRouteArray, this.map, this.route);
        }
      }
    },
  },
};
</script>

<style lang="scss">
.routeMap{
  color: var(--color-black);
  width: 35%;
  position: sticky !important;
  top: 100px;
  
  .routeMapInner{
    box-shadow: 0 15px 30px rgba(102, 105, 138, 0.1);
    transition: all ease .3s;
    border-radius: 8px;
    overflow: hidden;
  }

  .button-primary {
    margin: 15px 0 0 10px;
  }

  &.route-1{
    .title-mode-header{
      h2{
        color: var(--color-jade);
      }
    }
  }

  &.route-2{
    .title-mode-header{
      h2{
        color: var(--color-dark-blue);
      }
    }
  }

  &.route-3{
    .title-mode-header{
      h2{
        color: var(--color-violet);
      }
    }
  }

  .title-mode-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 5px;
    margin-bottom: 10px;
    padding-bottom: 5px;
    border-bottom: 1px solid #bbb;

    h2{
      margin: 0;
      font-size: 1.5rem;

      img{
        display: inline-block;
        height: 23px;
        margin: 0 5px;
        vertical-align: bottom;
      }
    }

    .routeModes{
      display: flex;

      .routeMode{
        width: 25px;

        &:not(:last-child){
          margin-right: 10px;
        }
      }
    }
  }

  .routeDetails{
    background: white;
    padding: 20px 25px;

    .routeDetail{
      display: flex;
      justify-content: space-between;
      font-size: 1rem;
      margin-top:5px;
    }

    .backToOverview{
      display: flex;
      align-items: center;
      margin-top: 20px;

      img{
        height: 18px;
        transform: rotate(180deg);
        margin-right: 8px;
      }
    }
  }

  .map-wrapper{
    position: relative;

    .map{
      width:100%;
      height: 550px;
    }

    .urs-favourite{
      position: absolute;
      display: none;
      bottom: 15px;
      right: 15px;
      z-index: 1;
      width: 50%;
      animation-name: 'urs-favourite';
      animation-iteration-count: infinite;
      animation-direction: alternate;
      animation-duration:1.5s;
      animation-timing-function: ease-in-out;
      transform-origin: bottom right;

      @media screen and (max-width: 1199px){
        width: 63%;
      }

      img{
        display: block;
        width: 100%;
      }

      figcaption{
        position: absolute;
        top: 0;
        width: 53%;
        left: 0;
        bottom: 63%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 27px;
        border-radius: 53%;
        flex-direction: column;
        text-align: center;
        font-size: .85rem;
        font-weight:600;
        line-height:1rem;
        color: var(--color-orange);

        p:not(:last-child){
          margin-bottom:5px;
        }
      }

      @keyframes urs-favourite {
        from {
          transform: rotate(0);
        }

        to {
          transform: rotate(2deg);
        }
      }
    }
  }

  &.route-2{
    .map-wrapper{
      .urs-favourite{
        display: block;
      }
    }
  }
}
</style>
